const GUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

/** إن كانت القيمة سلسلة GUID نعيدها (لحقول مثل answeredBy كنص فقط). */
function trimGuidString(v) {
  if (v == null || typeof v !== 'string') return ''
  const s = v.trim()
  return GUID_RE.test(s) ? s : ''
}

function pickFirstId(candidates) {
  for (const v of candidates) {
    if (v == null || v === '') continue
    const s = String(v).trim()
    if (s) return s
  }
  return ''
}

/**
 * كائن طبيب متداخل فقط (book.doctor أو doctor داخل الاستشارة).
 */
export function resolveDoctorProfileIdFromNested(doctorLike) {
  if (!doctorLike || typeof doctorLike !== 'object') return ''
  return pickFirstId([
    doctorLike.id,
    doctorLike.doctorID,
    doctorLike.DoctorID,
    doctorLike.doctorId,
    doctorLike.userId,
    doctorLike.userID,
    doctorLike.applicationUserId,
    doctorLike.providerId,
    doctorLike.ProviderId,
    doctorLike.applicationUserID,
  ])
}

/**
 * صف أو تفاصيل استشارة — لا يستخدم معرف الاستشارة نفسه.
 */
export function resolveDoctorProfileIdFromConsultationPayload(payload) {
  if (!payload || typeof payload !== 'object') return ''

  const guidCandidates = [
    trimGuidString(payload.answeredBy),
    trimGuidString(typeof payload.doctor === 'string' ? payload.doctor : ''),
    trimGuidString(typeof payload.expert === 'string' ? payload.expert : ''),
    trimGuidString(payload.answerDoctorGuid),
    trimGuidString(payload.doctorGuid),
    trimGuidString(payload.providerGuid),
  ]
  const guidPick = pickFirstId(guidCandidates)
  if (guidPick) return guidPick

  const inner =
    typeof payload.doctor === 'object' && payload.doctor
      ? payload.doctor
      : typeof payload.expert === 'object' && payload.expert
        ? payload.expert
        : typeof payload.consultant === 'object' && payload.consultant
          ? payload.consultant
          : typeof payload.provider === 'object' && payload.provider
            ? payload.provider
            : typeof payload.answeredBy === 'object' && payload.answeredBy
              ? payload.answeredBy
              : null

  const fromInner = resolveDoctorProfileIdFromNested(inner)
  if (fromInner) return fromInner

  return pickFirstId([
    payload.doctorID,
    payload.DoctorID,
    payload.doctorId,
    payload.expertId,
    payload.consultantId,
    payload.providerId,
    payload.providerUserId,
    payload.answeredById,
    payload.answeredByUserId,
    payload.respondentDoctorId,
    payload.answerDoctorId,
    payload.answerDoctorUserId,
    payload.doctorApplicationUserId,
    payload.doctorUserId,
    payload.replyDoctorId,
    payload.respondentId,
    payload.serviceProviderId,
    payload.DoctorId,
    payload.AnsweredById,
    payload.ProviderId,
    payload.ExpertId,
    payload.ConsultantId,
  ])
}

export function resolveDoctorProfileIdFromBook(book) {
  if (!book || typeof book !== 'object') return ''
  const nested = resolveDoctorProfileIdFromNested(book.doctor)
  if (nested) return nested
  return pickFirstId([book.doctorId, book.providerId])
}
